import { render, staticRenderFns } from "./EmbedIntroduction.vue?vue&type=template&id=67d5f149&scoped=true"
import script from "./EmbedIntroduction.vue?vue&type=script&lang=js"
export * from "./EmbedIntroduction.vue?vue&type=script&lang=js"
import style0 from "./EmbedIntroduction.vue?vue&type=style&index=0&id=67d5f149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5f149",
  null
  
)

export default component.exports